/**
 * Statistics Counter Animation Component
 * Animates numbers counting up when scrolled into view
 */
(function () {
  'use strict';

  class StatisticsCounter {
    constructor(container) {
      this.container = container;
      this.numbers = container.querySelectorAll('[data-stat-number]');
      this.duration = parseInt(container.dataset.animationDuration, 10) || 2000;
      this.hasAnimated = false;

      this.init();
    }

    init() {
      if (!this.numbers.length) return;

      // Use Intersection Observer to trigger animation when visible
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.hasAnimated) {
              this.hasAnimated = true;
              this.animateAll();
              observer.disconnect();
            }
          });
        },
        {
          threshold: 0.3,
          rootMargin: '0px 0px -50px 0px',
        }
      );

      observer.observe(this.container);
    }

    animateAll() {
      this.numbers.forEach((element) => {
        const target = parseInt(element.dataset.target, 10) || 0;
        this.animateNumber(element, target);
      });
    }

    animateNumber(element, target) {
      const startTime = performance.now();
      const startValue = 0;

      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / this.duration, 1);

        // Easing function (ease-out cubic)
        const easeOut = 1 - Math.pow(1 - progress, 3);
        const currentValue = Math.round(startValue + (target - startValue) * easeOut);

        element.textContent = this.formatNumber(currentValue);

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          element.textContent = this.formatNumber(target);
          element.dataset.animated = 'true';
        }
      };

      requestAnimationFrame(animate);
    }

    formatNumber(num) {
      // Format with locale-specific thousand separators
      return num.toLocaleString();
    }
  }

  // Initialize all statistics containers on page
  function initStatistics() {
    const containers = document.querySelectorAll('[data-statistics-container]');
    containers.forEach((container) => {
      if (!container.dataset.initialized) {
        new StatisticsCounter(container);
        container.dataset.initialized = 'true';
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStatistics);
  } else {
    initStatistics();
  }

  // Re-initialize for Shopify theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      const container = event.target.querySelector('[data-statistics-container]');
      if (container) {
        container.dataset.initialized = '';
        container.querySelectorAll('[data-stat-number]').forEach((el) => {
          el.textContent = '0';
          el.removeAttribute('data-animated');
        });
        new StatisticsCounter(container);
        container.dataset.initialized = 'true';
      }
    });
  }
})();
